import { adjustSessionQuery } from '../../../utils/adjustSessionQuery.js';
import { tableFunc } from '../../../utils/tableFunc.js';
import { isURL } from '../../../utils/url.js';
export const forwardQuery = (ev) => {
    const anchor = ev.target?.closest('a');
    if (isURL(anchor?.href) && !anchor?.href?.startsWith(globalThis.location?.origin)) {
        ev.preventDefault();
        ev.stopPropagation();
        const url = adjustSessionQuery(anchor?.href) || anchor?.href;
        if (url) {
            const transition = getTransition(anchor?.target);
            transition?.(url);
        }
    }
};
const getTransition = tableFunc([
    [(_) => _ === '_blank', (url) => globalThis.open(url, '_blank')],
    [(_) => _ === '_parent', (url) => globalThis.parent && (globalThis.parent.location.href = url)],
    [
        (_) => _ === '_top',
        (url) => {
            globalThis.top && (globalThis.top.location.href = url);
        },
    ],
    [() => true, (url) => globalThis.location && (globalThis.location.href = url)],
]);
//# sourceMappingURL=forwardQuery.js.map